import React, { useState } from "react";
import { RocketLaunch } from "@phosphor-icons/react";
import { INPUT } from "./obUi";

const BTN = "border-2 border-black px-4 py-2.5 text-[11px] font-bold uppercase tracking-widest transition-colors duration-100 disabled:opacity-40";

export const ObActions = ({ submitted, busy, onSave, onGoLive, onSendBack, onEmail, onDelete }) => {
  const [note, setNote] = useState("");
  const [back, setBack] = useState(false);
  const [sure, setSure] = useState(false);
  return (
    <div className="border-2 border-black bg-white p-5 space-y-4" data-testid="ob-actions">
      <div className="flex flex-wrap items-center gap-3">
        <button type="button" onClick={onGoLive} disabled={!!busy} data-testid="ob-go-live"
                className={`${BTN} bg-black text-white hover:bg-zinc-800 inline-flex items-center gap-2 px-6 py-3`}>
          <RocketLaunch size={16} weight="bold" /> {busy === "live" ? "Setting up…" : submitted ? "Approve and go live" : "Finish and go live"}
        </button>
        <button type="button" onClick={onSave} disabled={!!busy} className={`${BTN} hover:bg-zinc-100`} data-testid="ob-save">{busy === "save" ? "Saving…" : "Save for later"}</button>
        {submitted
          ? <button type="button" onClick={() => setBack((v) => !v)} disabled={!!busy} className={`${BTN} hover:bg-zinc-100`} data-testid="ob-send-back-toggle">Send back for changes</button>
          : <button type="button" onClick={onEmail} disabled={!!busy} className={`${BTN} hover:bg-zinc-100`} data-testid="ob-email-link">{busy === "email" ? "Sending…" : "Email link to buyer"}</button>}
        <button type="button" onClick={() => (sure ? onDelete() : setSure(true))} disabled={!!busy} data-testid="ob-delete"
                className={`${BTN} border-red-700 text-red-700 hover:bg-red-50`}>{sure ? "Click again to delete" : "Delete"}</button>
      </div>
      <p className="text-[11px] text-zinc-600">Going live creates the buyer, their lead delivery, rules and limits, thank-you page, testimonials and their own branded pages, then sends the login invite if they asked for one.</p>
      {back && (
        <div className="space-y-2" data-testid="ob-send-back-box">
          <textarea rows={3} className={INPUT} value={note} onChange={(e) => setNote(e.target.value)} placeholder="What should they change? (shown on their form and in the email)" data-testid="ob-send-back-note" />
          <button type="button" onClick={() => onSendBack(note)} disabled={!!busy} className={`${BTN} hover:bg-zinc-100`} data-testid="ob-send-back">{busy === "back" ? "Sending…" : "Send back"}</button>
        </div>
      )}
    </div>
  );
};
